<template lang="html">
  <div class="form">
    <span class="edit" v-show="!infoEditShow && role !== 2" @click="edit()">{{message.Sl127}}</span>
    <el-form  :model="projectNew" ref="rulesForm"  :rules="rules" label-width="260px">
      <div class="img">
        <el-upload
          v-show="infoEditShow"
          class="avatar-uploader"
          action="/cydex/api/v1/pic"
          :headers="headers"
          :data="{pic_type:'1'}"
          name="uploadfile"
          :show-file-list="false"
          :on-error="handleAvatarError"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="projectNew.imgUrl" :src="projectNew.imgUrl" class="avatar">
          <img v-if="defaultImg" src="../../../assets/images/project.png" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <img v-show="project.imgUrl===''&&projectNew.imgUrl===''" src="../../../assets/images/project.png" alt="">
        <img v-show="project.imgUrl!==''&&projectNew.imgUrl===''" :src="project.imgUrl" alt="">
      </div>
      <div class="restore">
        <el-button
          @click="resetImg"
          v-show="infoEditShow"
          style=""
          type="text">
          {{message.Sl134}}
        </el-button>
      </div>
      <el-form-item :label="message.Fl105"  prop="name" auto-complete="off" style="text-align:left">
        <!--Disallow updating workspace name for Arkhub (CYX-269)-->
        <el-input v-model.trim="projectNew.name" :disabled=true maxlength="32" style="width:300px" show-message="false" v-show="infoEditShow" maxlength:32></el-input>
        <span class="text-input-span">{{ project.name }}</span>
      </el-form-item>
      <el-form-item :label="message.Fl106"   auto-complete="off" style="text-align:left;height:80px;">
        <el-input
        type="textarea"
        resize="none"
        maxlength="100"
        v-show="infoEditShow"
        v-model="projectNew.description"
        :autosize="{ minRows: 3, maxRows: 3}"
        style="left:0;width:300px;margin: 0 auto;"
        >
        </el-input>
        <span v-show="!infoEditShow" class="text-area-span">{{ project.description }}</span>
      </el-form-item>
      <el-form-item style="margin-top:10px;text-align:right" label-width="0px" v-show="infoEditShow">
        <el-button type="primary" style="width:80px" size='small' @click="onSubmit">{{message.Fl126}}</el-button>
        <el-button style="width:80px" size="small" @click="reset()">{{message.Fl101}}</el-button>
      </el-form-item>
    </el-form>
    <el-button v-show="role === 0&&!infoEditShow" type="primary" size="small" class="out" @click="deleteProject">{{message.Sl135}}</el-button>
    <el-button v-show="role !== 0&&!infoEditShow" type="primary" size="small" class="out" @click="outProject">{{message.Sl136}}</el-button>
  </div>
</template>

<script>
import router from '@/router'
export default {
  data () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$lang.ui.prompt.l120))
      } else {
        callback()
      }
    }
    var timeZone = localStorage.getItem('timeZone')
    var token = localStorage.getItem('token')
    var language = localStorage.getItem('language')
    var headers = {
      'x-us-authtype': '1',
      'x-us-token': token,
      'accept-language': language,
      'time-zone': timeZone
    }
    return {
      message: {
        Fl100: this.$lang.ui.form.l100,
        Fl101: this.$lang.ui.form.l101,
        Fl126: this.$lang.ui.form.l126,
        Fl105: this.$lang.ui.form.l105,
        Fl106: this.$lang.ui.form.l106,
        Sl127: this.$lang.ui.system.l127,
        Sl134: this.$lang.ui.system.l134,
        Sl135: this.$lang.ui.system.l135,
        Sl136: this.$lang.ui.system.l136
      },
      headers: headers,
      infoEditShow: false,
      defaultImg: false,
      project: {
        name: '',
        description: '',
        imgUrl: ''
      },
      projectNew: {
        name: '',
        description: '',
        imgUrl: ''
      },
      rules: {
        name: [{ validator: checkName, trigger: 'blur' }]
      }
    }
  },
  props: {
    id: String,
    role: Number,
    name: String
  },
  mounted () {
    this.projectList()
  },
  methods: {
    beforeAvatarUpload (file) {
      this.defaultImg = false
      var type = file.type.split('/')
      type = type[0]
      const isLt1M = file.size / 1024 < 500
      const isImg = type === 'image'
      if (!isImg) {
        this.$message.warning(this.$lang.ui.prompt.l121)
      }
      if (!isLt1M) {
        this.$message.warning(this.$lang.ui.prompt.l122)
      }
      return isImg && isLt1M
    },
    handleAvatarError () {
      this.$message({
        message: this.$lang.ui.prompt.l123,
        type: 'error',
        duration: 3 * 1000
      })
    },
    handleAvatarSuccess (res, file) {
      this.projectNew.imgUrl = res.pic_url
    },
    resetImg () {
      this.projectNew.imgUrl = ''
      this.defaultImg = true
    },
    projectList () {
      this.$api.getProject(this.id, response => {
        this.project.name = response.project.name
        this.project.description = response.project.description
        this.project.imgUrl = response.project.pic_url
        this.$emit('getName', this.project.name)
      })
    },
    edit () {
      this.infoEditShow = true
      this.projectNew.name = this.project.name
      this.projectNew.description = this.project.description
    },
    reset () {
      this.projectNew.imgUrl = ''
      this.defaultImg = false
      this.infoEditShow = false
      this.$refs['rulesForm'].resetFields()
    },
    onSubmit () {
      this.$refs['rulesForm'].validate(vaild => {
        if (vaild) {
          if (this.defaultImg) {
            var imgUrl = ''
          } else {
            if (this.projectNew.imgUrl === '') {
              imgUrl = this.project.imgUrl
            } else {
              imgUrl = this.projectNew.imgUrl
            }
          }
          this.$http
            .put('/cydex/api/v1/projects/' + this.id, {
              name: this.projectNew.name,
              description: this.projectNew.description,
              pic_url: imgUrl
            })
            .then(response => {
              this.$message({
                message: this.$lang.ui.prompt.l117,
                type: 'success',
                duration: 4000
              })
              this.infoEditShow = false
              this.project.name = this.projectNew.name
              this.project.description = this.projectNew.description
              this.project.imgUrl = imgUrl
              this.projectNew.imgUrl = ''
              this.$refs['rulesForm'].resetFields()
              this.$store.dispatch('updateEl', 'workspaceList')
              var data = {
                role: this.role,
                type: 'workspace',
                spaceName: this.project.name,
                name: 'workspaceInfo',
                id: this.id
              }
              this.$store.dispatch('showOther', data)
              this.projectList()
              // if (this.id === localStorage.getItem('projectId')) {
              //   localStorage.setItem('projectName', this.project.name)
              //   localStorage.setItem('projectUrl', this.project.imgUrl)
              //   var newData = {
              //     id: this.id,
              //     name: this.project.name,
              //     imgUrl: this.project.imgUrl
              //   }
              //   this.$store.dispatch('addSpace', newData)
              // }
            })
        }
      })
    },
    deleteProject () {
      this.$prompt(
        `${this.$lang.ui.prompt.l158}<br/>${this.$lang.ui.prompt.l124}`,
        this.$lang.ui.system.l132,
        {
          confirmButtonText: this.$lang.ui.form.l100,
          cancelButtonText: this.$lang.ui.form.l101,
          inputPattern: /^DELETE$/,
          inputErrorMessage: this.$lang.ui.prompt.l125,
          dangerouslyUseHTMLString: true
        }
      )
        .then(({ value }) => {
          this.$http
            .delete('/cydex/api/v1/projects/' + this.id)
            .then(response => {
              this.$store.dispatch('updateEl', 'workspaceList')
              this.$store.dispatch('showOther', '')
              this.$message({
                message: this.$lang.ui.prompt.l126,
                type: 'success',
                duration: 4000
              })
              this.$http.get('/cydex/api/v1/projects', { params: {
                type: 3
              } })
                .then(response => {
                  if (response.data.projects) {
                    // next()
                  } else {
                    router.push({ path: '/app/initial' })
                  }
                })
            })
        })
        .catch(() => {})
    },
    outProject () {
      this.$confirm(this.$lang.ui.prompt.l127, this.$lang.ui.system.l133, {
        confirmButtonText: this.$lang.ui.form.l100,
        cancelButtonText: this.$lang.ui.form.l101,
        type: 'warning'
      })
        .then(() => {
          this.$http
            .post('/cydex/api/v1/projects/' + this.id + '/leave')
            .then(response => {
              this.$store.dispatch('updateEl', 'workspaceList')
              this.$store.dispatch('showOther', '')
              this.$message({
                message: this.$lang.ui.prompt.l128,
                type: 'success',
                duration: 4000
              })
              this.$http.get('/cydex/api/v1/projects', { params: {
                type: 3
              } })
                .then(response => {
                  if (response.data.projects) {
                    // next()
                  } else {
                    router.push({ path: '/app/initial' })
                  }
                })
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="css" scoped>
.form {
  position: relative;
  background-color: #fff;
  padding: 20px 30px 20px 20px;
  width: 610px;
  border-radius: 4px;
  margin: 15px auto;
  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.149019607843137);
}
.el-form {
  margin-top: 30px;
}
.img {
  position: absolute;
  top: 35px;
  left: 30px;
  background-color: #fff;
  width: 150px;
  height: 150px;
  border-radius: 150px;
  overflow: hidden;
}
.avatar {
  border-radius: 150px;
}
.img img {
  background-color: #fff;
  width: 150px;
  height: 150px;
}
.avatar-uploader {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.4);
  width: 150px;
  height: 150px;
  text-align: center;
  border-radius: 150px;
}
.avatar-uploader-icon {
  color: rgba(255, 255, 255, 0.5);
  margin-top: 45px;
  font-size: 60px;
}
.text-area-span {
  width: 100%;
  display: block;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-line-clamp: 2;
}
.text-input-span {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.title {
  font-size: 14px;
  text-align: left;
  font-weight: 600;
  margin-bottom: 18px;
}
.edit {
  position: absolute;
  cursor: pointer;
  color: #007bc5;
  top: 20px;
  right: 25px;
  display: block;
  font-size: 14px;
  font-weight: 600;
}
.form:hover .edit {
  display: block;
}
.el-input {
  position: absolute;
  left: 0;
}
.out {
  position: absolute;
  bottom: -300px;
  left: 0;
}
.restore {
  position: absolute;
  text-align: center;
  width: 210px;
  z-index: 3;
  left: 5px;
  top: 195px;
}
/* .form >>> .el-form-item__content {
  display: -webkit-box;
  -webkit-box-orient:vertical;
  overflow:hidden;
  text-overflow:ellipsis;
  line-clamp:2;
  -webkit-line-clamp:2;
} */
</style>
